<template>
    <v-container class="pa-0 mt-6" fluid>
        <v-row justify="space-between">
            <v-col>
                <div class="text-left mt-2"
                    v-for="link in links1" 
                    :key="link.text">
                    <footer-link :path=link.path :text=link.text></footer-link>
                </div>
            </v-col>
            <v-col>
                <div class="text-center mt-2"
                    v-for="link in links2"
                    :key="link.text">
                    <footer-link :path=link.path :text=link.text></footer-link>
                </div>
            </v-col>
            <v-col>
                <div class="text-right mt-2" 
                    v-for="link in links3" 
                    :key="link.text">
                    <footer-link :path=link.path :text=link.text></footer-link>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import FooterLink from '@/components/footer/FooterLink.vue';
export default {
    name: 'FooterNavigation',
    components: {
        FooterLink
    },
    data () {
        return {
            links1: [
                { path: '/about', text: 'О РАИИ' },
                { path: '/all_news_page', text: 'Новости' },
                { path: '/all_conferences', text: 'Конференции' },
                { path: '/all_personalities', text: 'Персоналии' },
                { path: '/about/raai_documents/bank_details', text: 'Документы' },
                { path: '/library', text: 'Библиотека' },
            ],
            // links2: [
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            // ],
            // links3: [
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            //     { path: '/', text: 'text text text' },
            // ]
        }
    }

}
</script>